<app-loader *ngIf="!contractorType"></app-loader>

<wm-modal-confirm
  #registerPublishHistory
  [showButtonText]="false"
  [showButton]="false"
  buttonText="Publish History"
  commandText="Close"
  [showCancelButton]="false"
  title="Workflow Publish History"
  btnColor="primary"
  class="mx-2"
  [closeOnAccept]="true"
>
  <wm-workflow-publish-history
    *ngIf="
      contractorType?.registerWorkflowId &&
      (registerPublishHistory?.isOpen() || false)
    "
    [workflowId]="contractorType.registerWorkflowId"
  ></wm-workflow-publish-history>
</wm-modal-confirm>

<wm-modal-confirm
  #renewPublishHistory
  [showButtonText]="false"
  [showButton]="false"
  buttonText="Publish History"
  commandText="Close"
  [showCancelButton]="false"
  title="Workflow Publish History"
  btnColor="primary"
  class="mx-2"
  [closeOnAccept]="true"
>
  <wm-workflow-publish-history
    *ngIf="
      contractorType?.renewWorkflowId &&
      (renewPublishHistory?.isOpen() || false)
    "
    [workflowId]="contractorType.renewWorkflowId"
  ></wm-workflow-publish-history>
</wm-modal-confirm>

<div *ngIf="context && context.client && contractorType">
  <div class="row mb-3">
    <div class="col-6">
      <div class="row">
        <div class="col-auto">
          <h3>{{ contractorType.name }}</h3>
          <p>
            {{ contractorType.description }}
          </p>
        </div>

        <div class="col" *ngIf="canEdit">
          <div class="d-flex justify-content-end align-items-center">
            <div class="btn-group mr-2" ngbDropdown placement="bottom-right">
              <button
                type="button"
                class="btn btn-raised btn-primary"
                [routerLink]="[
                  '/admin/workflow-builder',
                  contractorType.registerWorkflowId
                ]"
              >
                Register Builder
              </button>
              <button
                class="btn btn-raised btn-primary dropdown-toggle-split"
                ngbDropdownToggle
              ></button>
              <div class="dropdown-menu" ngbDropdownMenu>
                <button ngbDropdownItem (click)="registerPublishHistory.open()">
                  Publish History
                </button>
              </div>
            </div>

            <div class="btn-group mr-2" ngbDropdown placement="bottom-right">
              <button
                type="button"
                class="btn btn-raised btn-primary"
                [routerLink]="[
                  '/admin/workflow-builder',
                  contractorType.renewWorkflowId
                ]"
              >
                Renew Builder
              </button>
              <button
                class="btn btn-raised btn-primary dropdown-toggle-split"
                ngbDropdownToggle
              ></button>
              <div class="dropdown-menu" ngbDropdownMenu>
                <button ngbDropdownItem (click)="renewPublishHistory.open()">
                  Publish History
                </button>
              </div>
            </div>
            <button
              class="btn btn-raised btn-default"
              [routerLink]="[
                '/admin/jurisdiction',
                context.client.id,
                'contractors',
                'types',
                'edit',
                contractorType.id
              ]"
            >
              Edit
            </button>
            <button
              *ngIf="isGlobalAdmin"
              class="btn btn-raised btn-default ml-2"
              (click)="exportContractorType()"
              title="Export this contractor type to a JSON file for import into another environment"
            >
              Export
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-auto">
              <p class="text-muted">Registration Fee</p>
              <h4>{{ contractorType.registrationFee }}</h4>
            </div>
            <div class="col-auto">
              <p class="text-muted">Renewal Fee</p>
              <h4>{{ contractorType.renewalFee }}</h4>
            </div>
            <div class="col-auto">
              <p class="text-muted">Last Published On</p>
              <h4 *ngIf="contractorType.registerWorkflow.lastPublishedOn">
                <span>
                  {{ contractorType.registerWorkflow.lastPublishedOnString }}
                  by
                  {{ contractorType.registerWorkflow.lastPublishedBy }}
                </span>
              </h4>
              <span
                *ngIf="!contractorType.registerWorkflow.lastPublishedOn"
                class="badge badge-pill badge-warning"
              >
                Never published
              </span>
              <span
                *ngIf="
                  contractorType.registerWorkflow.lastPublishedOn &&
                  (contractorType.registerWorkflow
                    .areThereChangesNotPublished ||
                    contractorType.renewWorkflow.areThereChangesNotPublished)
                "
                class="badge badge-pill badge-success"
              >
                Changes available
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <h4>Contractors</h4>

      <wm-contractor-registration-list
        [id]="id"
        [additionalCommands]="commands"
        [initialColumns]="columns"
        [staticFilters]="filterOptions"
        [dynamicColumnsVisibleByDefault]="dynamicColumnsVisibleByDefault"
      >
      </wm-contractor-registration-list>
    </div>
  </div>
</div>
